interface WhiteCrossIconProps {
  width?: number;
  height?: number;
}
const WhiteCrossIcon: React.FC<WhiteCrossIconProps> = ({
  width = 11,
  height = 11,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00656 0.0195635C4.35108 0.0817697 3.61795 0.290786 3.05053 0.577248C2.46351 0.873597 1.84903 1.34251 1.42797 1.81544C0.602054 2.74309 0.133402 3.81551 0.0202098 5.03691C-0.0686714 5.99595 0.13884 7.07733 0.57914 7.94947C0.87549 8.53649 1.3444 9.15096 1.81733 9.57203C2.74498 10.3979 3.8174 10.8666 5.03881 10.9798C5.99784 11.0687 7.07923 10.8612 7.95136 10.4209C8.53838 10.1245 9.15286 9.6556 9.57392 9.18267C10.3998 8.25502 10.8685 7.18259 10.9817 5.96119C11.0706 5.00216 10.8631 3.92077 10.4228 3.04864C10.1264 2.46162 9.65749 1.84714 9.18456 1.42608C8.25691 0.600161 7.18449 0.131509 5.96309 0.0183168C5.69449 -0.0065742 5.27628 -0.00603683 5.00656 0.0195635ZM8.40445 3.88879C8.82568 4.34953 8.83729 4.36466 8.79796 4.40168C8.77567 4.42263 7.90138 5.21642 6.85512 6.16561C5.80886 7.1148 4.92594 7.91624 4.89307 7.94659L4.83329 8.00174L3.63029 6.79889L2.42729 5.59604L2.88386 5.1391L3.34041 4.68216L4.10653 5.44807C4.5279 5.86932 4.88103 6.20877 4.89124 6.20241C4.90148 6.19604 5.5966 5.56622 6.43597 4.80283C7.27535 4.03942 7.96398 3.41465 7.96626 3.41444C7.96853 3.41422 8.16573 3.62769 8.40445 3.88879Z"
        fill="white"
      />
    </svg>
  );
};

export default WhiteCrossIcon;
